import { supabase } from '../supabaseClient';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const SHA256 = /^[0-9a-f]{64}$/;

function fail(message = 'Autorité du plan externe indisponible.') {
  throw new Error(message);
}

export function validateExternalPlanAuthority(value, expected = {}) {
  if (!value || typeof value !== 'object' || Array.isArray(value)
      || typeof value.authorized !== 'boolean' || typeof value.persisted !== 'boolean'
      || typeof value.validated !== 'boolean'
      || !(value.authorityId === null || UUID.test(value.authorityId || ''))
      || !SHA256.test(value.planHash || '')
      || !(value.profileSummaryHash === null || SHA256.test(value.profileSummaryHash || ''))
      || !(value.revision === null || (Number.isInteger(value.revision) && value.revision >= 1))
      || (value.authorized && (!value.persisted || !UUID.test(value.authorityId || '')
        || !SHA256.test(value.profileSummaryHash || '') || !Number.isInteger(value.revision)))) {
    fail();
  }
  if (expected.planHash && value.planHash !== expected.planHash) fail('Le texte ne correspond plus à l’autorité externe.');
  if (expected.profileSummaryHash
      && value.profileSummaryHash !== expected.profileSummaryHash) {
    fail('La synthèse relue ne correspond plus à l’autorité externe.');
  }
  return Object.freeze({ ...value });
}

export function createExternalPlanAuthorityClient(db = supabase) {
  return Object.freeze({
    async status({ clientId, consultationId, planHash = null, profileSummaryHash = null }) {
      if (!UUID.test(clientId || '') || !UUID.test(consultationId || '')) fail();
      const { data, error } = await db.rpc('lire_autorite_plan_externe', {
        p_client_id: clientId,
        p_consultation_id: consultationId,
      });
      if (error || !data) fail(error?.message);
      return validateExternalPlanAuthority(data, { planHash, profileSummaryHash });
    },
  });
}

export const externalPlanAuthorityClient = createExternalPlanAuthorityClient();
